import { useEffect, useReducer } from 'react';
import { useParams } from 'react-router-dom';

import axios from 'axios';
import { getReducer } from '../../../../utils';
import LoadingBox from '../../../compoment/LoadingBox';
import MessageBox from '../../../compoment/MessageBox';

import '../css/culturePost.css';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS_POST':
      return { ...state, post: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const CulturePost = ({ setPageShow }) => {
  const [{ loading, error, post }, dispatch] = useReducer(getReducer(reducer), {
    post: null,
    loading: true,
    error: '',
  });

  const params = useParams();
  const { slug = null } = params;

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const resultPost = await axios.get(`/post/show/${slug}`);
        dispatch({ type: 'FETCH_SUCCESS_POST', payload: resultPost.data.data });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, [slug]);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div className="bg-white shadow-lg mb-3 culture-post px-lg-5 px-3">
      <h1 className="text-center default-box-title m-0">{post.title}</h1>

      <div className="d-flex">
        <div className="content" id="content">
          <article>
            {post.content ? (
              <div dangerouslySetInnerHTML={{ __html: post.content }} />
            ) : (
              <p>Không có nội dung.</p>
            )}
          </article>
        </div>
      </div>

      <div className="redirect">
        <h3>Thành Đồng – Chất lượng cao cho mọi công trình</h3>
        <p>Thành Đồng Group đang chờ bạn. Gia nhập và khám phá ngay!</p>
        <button
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => setPageShow(1), 500);
          }}
        >
          Các vị trí đang tuyển
        </button>
      </div>
    </div>
  );
};

export default CulturePost;
